export default __webpack_public_path__ + "static/media/logo04.2b992b6d.png";